/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ex_NoteInputs */

const en_to_csv_ex_note = /** @type {(inputs: To_Csv_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The header is the union of all keys in first seen order, so tags is last even though it belongs to the second record. Cells for keys a record does not have are empty, and so is the cell for the null score.`)
};

const ko_to_csv_ex_note = /** @type {(inputs: To_Csv_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헤더는 처음 등장한 순서로 된 모든 키의 합집합이므로, tags는 두 번째 레코드의 것이지만 마지막에 옵니다. 레코드에 없는 키의 칸은 비어 있고, null인 score의 칸도 비어 있습니다.`)
};

const ja_to_csv_ex_note = /** @type {(inputs: To_Csv_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダは最初に現れた順のすべてのキーの和集合なので、tags は 2 件目のレコードのものですが最後に来ます。レコードが持たないキーのセルは空で、null の score のセルも空です。`)
};

/**
* | output |
* | --- |
* | "The header is the union of all keys in first seen order, so tags is last even though it belongs to the second record. Cells for keys a record does not have a..." |
*
* @param {To_Csv_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ex_note = /** @type {((inputs?: To_Csv_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ex_note(inputs)
	if (locale === "ko") return ko_to_csv_ex_note(inputs)
	return ja_to_csv_ex_note(inputs)
});